import React from "react";

export function validationMessageContent(errorMessage: string): JSX.Element | null {
    if (!errorMessage) {
        return null;
    }

    // d-block class below ensures the div is displayed otherwise for the DatePicker the invalid-feedback css class was 
    // set to display:none. I think this is because the DatePicker control wraps the input so the message below is not
    // the next element after the form input control.
    return (
        <div className="invalid-feedback d-block">
            {errorMessage}
        </div>
    );
}